<template>
  <main class="content__page">
    <section class="entry format-standard">
      <div class="content__page-header">
        <h2>
          <i class="fa fa-cogs" aria-hidden="true"></i>
          {{ $t('subscription.manage_title') }}
        </h2>
      </div>

      <el-form ref="subscriptionForm" :model="form" :rules="rules" label-position="top" class="subscription-form">
        <p>{{ $t('subscription.enter_email') }}</p>

        <el-form-item :label="$t('form_labels.email')" prop="email">
          <el-input v-model="form.email" :placeholder="$t('form_labels.email_placeholder')" />
        </el-form-item>

        <div class="form-actions">
          <!-- <el-button @click="router.push('/')">{{ $t('buttons.cancel') }}</el-button> -->
          <el-button type="secondary" @click="validateAndSubmit">{{ $t('subscription.send_link') }}</el-button>
        </div>
      </el-form>
    </section>
  </main>
</template>

<script>
import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from "vue-i18n";
import { ElNotification } from "element-plus";
import { REQUEST_NEWSLETTER_SUBSCRIPTION_MAGIC_LINK } from "@/graphql/newsletter-subscriptions";
import apolloClient from "@/services/apollo-client";

export default {
  name: 'MobileManageSubscriptionPage',
  setup() {
    const router = useRouter();
    const { t } = useI18n();
    const subscriptionForm = ref(null);

    const form = reactive({
      email: ""
    });

    const rules = reactive({
      email: [
        { required: true, message: t("form_rules.email_required"), trigger: "blur" },
        { type: "email", message: t("form_rules.email_invalid"), trigger: ["blur", "change"] }
      ]
    });

    const validateAndSubmit = () => {
      subscriptionForm.value.validate(async (valid) => {
        if (!valid) {
          return;
        }

        try {
          const { data } = await apolloClient.mutate({
            mutation: REQUEST_NEWSLETTER_SUBSCRIPTION_MAGIC_LINK,
            variables: { email: form.email }
          });

          const response = data?.requestNewsletterSubscriptionMagicLink;

          if (response?.success) {
            ElNotification({
              title: t("notifications.success.title"),
              message: t("notifications.subscriptions.magic_link_sent"),
              type: "success"
            });

            // Handle reason-based messaging
            let message;
            let responseType = response?.success ? "success" : "error";

            switch (response?.reason) {
              case "NEWSLETTER_SUBSCRIPTION_NOT_FOUND":
                message = t("notifications.subscriptions.subscription_not_found");
                break;
              case "NEWSLETTER_MAGIC_LINK_SENT":
                message = t("notifications.subscriptions.magic_link_sent");
                break;
              case "GENERIC":
              default:
                message = response?.message || t("notifications.subscriptions.magic_link_error");
                break;
            }

            ElNotification({
              title: t("notifications."+responseType+".title"),
              message,
              type: responseType,
              duration: 30000
            });


            router.push({ name: 'HomePage' });
          } else {
            if (response?.reason === "USER_NOT_FOUND") {
              setTimeout(() => {
                // Follow-up notification
                ElNotification({
                  title: t("notifications.subscriptions.subscription_signup_title"),
                  message: t("notifications.subscriptions.subscription_signup_message"),
                  duration: 30000
                });

                router.push({ name: 'MobileSubscribePage' });
              }, 2000);
            }
          }
        } catch (error) {
          console.error("Magic link request error:", error);
          ElNotification({
            title: t("notifications.error.title"),
            message: error.message || t("notifications.subscriptions.magic_link_error"),
            type: "error"
          });
        }
      });
    };

    return {
      router,
      subscriptionForm,
      form,
      rules,
      validateAndSubmit
    };
  }
};
</script>

<style scoped>
::v-deep(.centered-container) {
  display: block !important;
}

.content__page {
  max-width: 600px;
  margin:0px auto;
  padding:0px;
}

.entry {
  width: 100%;
}

.form-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

</style> 